import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';

/**
 * @param {string} id
 * @param {string} name
 * @param {string} value
 * @param {string} description
 * @param {string} placeholder
 */
const StyledNekoTextArea = Styled(props => {
  const { id, name, value = '', description, placeholder = '', onEnter = null, readOnly = false, 
    maxLength = 3, className, style, ...rest } = props;

  const [ newValue, setNewValue ] = useState(value);
  const isControlled = !!props.onChange;

  useEffect(() => {
    if (!isControlled) {
      setNewValue(value);
    }
  }, [ value ]);

  const onChange = (e) => {
    if (isControlled) { 
      props.onChange(e.target.value, id);
    }
    else {
      setNewValue(e.target.value, id);
    }
  };

  const onKeyPress = (e) => {
    if (onEnter && event.key === 'Enter') {
      e.preventDefault();
      props.onEnter(e.target.value, id);
    }
  };

  const onBlur = (e) => {
    if (props.onBlur && value !== e.target.value) {
      props.onBlur(e.target.value, id);
    }
  };

  return (
    <div className={[className].join(' ')} style={style}>
      <textarea className="neko-textarea" {...rest} id={id} name={name} spellCheck="false" placeholder={placeholder} 
        onChange={onChange} onKeyPress={onKeyPress} onBlur={onBlur} readOnly={readOnly}>
        {isControlled ? value : newValue}
      </textarea>
      {description && <p className="neko-input-description">{description}</p>}
    </div>
  );
})`
  .neko-textarea {
    font-family: ${Theme.fontFamily};
    font-size: ${Theme.fontSizeText};
    border: 2px solid ${Theme.blue};
    box-sizing: border-box;
    height: 160px;
    background: rgb(0 124 186 / 10%);
    padding: 0 10px;
    width: 100%;

    &::placeholder {
      color: rgba(0, 0, 0, 0.25);
    }

    :focus {
      background-color: white;
    }

    :read-only {
      background-color: ${Theme.gray};
    }
  }

  .neko-input-description {
    font-family: ${Theme.fontFamily};
    font-size: ${Theme.fontSizeSmall};
    line-height: 14px;
    margin-top: 8px;
    margin-bottom: 0;
  }
`;

const NekoTextArea = (props) => {
  return (<StyledNekoTextArea {...props} />);
};

NekoTextArea.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  description: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onEnter: PropTypes.func,
  onBlur: PropTypes.func,
  readOnly: PropTypes.bool
};

NekoTextArea.defaultProps = {
  id: undefined,
  name: undefined,
  value: '',
  description: undefined,
  placeholder: '',
  onChange: undefined,
  onEnter: undefined,
  onBlur: undefined,
  readOnly: false
};

export { NekoTextArea };
